export enum NumberOfCasesFilterValue {
  ZERO = "ZERO",
  MORE_THAN_ZERO = "MORE_THAN_ZERO",
  ALL = "ALL",
}
